import kfetch from '@kareo/kfetch';
import rollbar from 'shared-assets/src/errors/errors';

/**
 * @constant
 * @type {string}
 */
export const TIERED_PRICING_ENDPOINT_URL =
  '/common-ui/api/customer/is-tiered-pricing';
const TIERED_PRICING_KEY = 'tiered-pricing';

const TieredPricing = {
  /**
   * Checks if there is a conflict in the period of time for the specified resource or provider
   * Warning: This function do not throw an exeption when the endpoint fails, instead return 0.
   * @warning :
   * @async
   * @function isTieredPricing
   * @param {Number} editionSetId - (optional) The id that identifies the customer edition set and the tiered pricing
   * @return {boolean} - Returns if the customer uses a tiered pricing
   */
  isTieredPricing: async editionSetId => {
    try {
      let isTieredPricing = sessionStorage.getItem(TIERED_PRICING_KEY);

      // If we already has the value then return that value
      if (isTieredPricing !== null && isTieredPricing !== undefined) {
        return JSON.parse(isTieredPricing);
      }

      // If we don't have the value then call to common-ui to get the value
      const params = new URLSearchParams();
      if (!!editionSetId) {
        params.append('editionSetId', editionSetId);
      }
      const res = await kfetch(
        `${TIERED_PRICING_ENDPOINT_URL}?${params.toString()}`,
      );
      // Store the value in the session storage.
      if (res !== null) {
        sessionStorage.setItem(TIERED_PRICING_KEY, res);
        return res;
      }
      // If the response is not correct then return false
      return false;
    } catch (err) {
      rollbar.error(err);
      // In case we find an error then it should behave as GBB is disabled
      return false;
    }
  },
  cleanTieredPricing: () => {
    sessionStorage.removeItem(TIERED_PRICING_KEY);
  },
};

export default TieredPricing;
